var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"analog-items"},_vm._l((_vm.analogsFirstPart),function(analog){return _c('RPHProductCard',{key:analog.id,attrs:{"product-data":analog,"type":'vertical',"additional-key":"product-analogue"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }